
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateChatMessageDtoFormGroup() {
return new FormGroup({
    body: new FormControl<string | undefined>(undefined, [Validators.maxLength(10000)]),
    replyToMessageId: new FormControl<number | undefined>(undefined, [Validators.min(1)]),
    documentIds: new FormControl<Array<number> | undefined>([]),
})
;
}
      